module.exports = __webpack_public_path__ + "febe47705eb5154ccbd257da0b66b011.png";